<template>
  <el-aside :class="{ open: !isCollapse }">
    <div class="top-logo"><img :src="logo" /></div>

    <div class="sidebar">
      <el-menu ref="ment" :default-active="this.$route.path" class="el-menu-vertical-demo" active-text-color="#ffd04b"
        router unique-opened :collapse="isCollapse" :collapse-transition="true" @select="menuSelect">
        <template v-for="item in this.routes">
          <template v-if="!item.children && !item.hidden">
            <el-menu-item :key="item.menuId" :index="item.path">
              <template slot="title">
                <span slot="title" @click="clickMenu(item)">{{ item.meta.title }}</span></template>
            </el-menu-item>
          </template>
          <template v-if="item.children && !item.hidden">
            <el-menu-item v-if="item.children.length === 1" :key="item.children[0].menuId" :index="item.children[0].path">
              <template slot="title">
                <span slot="title" @click="clickMenu(item.children[0])">{{
                  item.children[0].meta.title
                }}</span></template>
            </el-menu-item>
            <el-submenu v-else :key="item.path" :index="item.path" @click="clickMenu(item)">
              <template slot="title">
                <span slot="title">{{ item.meta.title }}</span></template>
              <el-menu-item-group>
                <el-menu-item v-for="subItem in subMenus(item.children)" :key="subItem.menuId"
                  style="padding-left: 40px !important" :index="subItem.path">
                  {{ subItem.meta.title }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </template>
        </template>
        <i class="el-icon-s-fold" :class="{ open: isCollapse }" @click="isCollapse = !isCollapse"></i>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
import logo from '@/assets/images/logo.png'

export default {
  props: ['siderBarWidth', 'items'],
  data() {
    return {
      itemsOld: [],
      onRouter: this.$route.path,
      howWidth: this.siderBarWidth,
      isCollapse: false,
      onlyOneChild: null,
      logo
    }
  },
  computed: {
    // 去除hidden:true的路由
    subMenus() {
      return (menus) => {
        return menus.filter((item) => !item.hidden)
      }
    },
    routes() {
      return this.$router.options.routes
    }
  },
  watch: {
    items() {
      if (this.items && this.items.length === 0) {
        this.items = this.itemsOld
      }
    }
  },

  created() {
    const list = JSON.parse(sessionStorage.getItem('tabViews')) || []
    for (let i = 0; i < list.length; i++) {
      this.$store.commit('tagsView/ADD_VISITED_VIEW', list[i])
    }
    if (list.length == 0) {
      this.$store.commit('tagsView/ADD_VISITED_VIEW', this.items[0])
    }
  },
  mounted() {
    this.itemsOld = this.items
    this.$nextTick(() => {
      if (this.items && this.items.length === 0) {
        this.items = this.itemsOld
      }
    })
  },
  methods: {
    clickMenu(val) {
      this.$store.commit('addView', val)
    },
    hasOneShowingChild(children = []) {
      const showingChildren = children.filter((item) => {
        return !item.hidden
      })

      if (showingChildren.length === 1) {
        const [first] = showingChildren
        this.onlyOneChild = first
        return true
      }

      return false
    },
    menuSelect(index, indexPath) {
      sessionStorage.setItem('crrpath', index)

      // this.onRouter = index
      this.$router.push(index)
    }
  }
}
</script>

<style scoped lang="scss">
.el-aside {
  position: fixed;
  padding-top: 80px;
  background-color: #fff;
}

.top-logo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  height: 80px;
  justify-content: center;
  align-items: center;

  img {
    height: 50px;
  }
}

.sidebar {
  height: 100%;

  overflow-y: auto;
  overflow-x: hidden;
}

.el-aside {
  width: auto !important;
}

.el-menu-vertical-demo {
  width: 500px;
  min-height: 400px;
  height: auto;
}

.el-icon-s-unfold {
  position: relative;
  left: 130px;
  font-size: 25px;
  cursor: pointer;
}

.el-icon-s-unfold.open {
  left: 17px;
}

.el-icon-s-fold {
  transform: translateY(-50%) !important;
}

.el-menu-vertical-demo .el-menu {
  transition: width 5s !important;
}

.sidebar>>>.el-menu-item-group .el-menu-item {
  padding-left: 40px !important;
}
</style>
